import { render, staticRenderFns } from "./ostosrahoitus.vue?vue&type=template&id=52413a08&"
import script from "./ostosrahoitus.vue?vue&type=script&lang=js&"
export * from "./ostosrahoitus.vue?vue&type=script&lang=js&"
import style0 from "./ostosrahoitus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports